var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"touch-feedback",rawName:"v-touch-feedback"}],staticClass:"tag",on:{"click":_vm.more}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }